// "1st", "2nd", "3rd", "4th", "11th", "21st": the visit label ("3rd visit"). English only, like the rest of the app's copy (en.json is the only translation).
const SUFFIX: Record<string, string> = { one: "st", two: "nd", few: "rd", other: "th" };
const rules = new Intl.PluralRules("en", { type: "ordinal" });

export const ordinal = (n: number): string => {
  if (!Number.isFinite(n) || !Number.isInteger(n)) {
    return "";
  }

  return `${n}${SUFFIX[rules.select(n)] ?? "th"}`;
};

// The visit label a returning row carries: "3rd visit". Empty when the number is unknown or is 1 (a first visit is "new", not a visit to count).
export const visitLabel = (visitNumber: unknown, visitWord: string): string =>
  typeof visitNumber === "number" && Number.isInteger(visitNumber) && visitNumber >= 2 ? `${ordinal(visitNumber)} ${visitWord}` : "";
